import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"backgroundImage") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":2},"end":{"line":10,"column":9}}})) != null ? stack1 : "")
    + "		<section class=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0))
    + " wrapper-preferred-rewards\">\n			<div class=\"row\">\n				<div class=\"small-12 column left-main "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"backgroundImage") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":42},"end":{"line":13,"column":96}}})) != null ? stack1 : "")
    + "\">\n					<div class=\"left-content\">\n						<img src=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? lookupProperty(stack1,"img") : stack1), depth0))
    + "\" alt=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? lookupProperty(stack1,"alt") : stack1), depth0))
    + "\" aria-hidden=\"true\"/>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"top-header") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":6},"end":{"line":18,"column":13}}})) != null ? stack1 : "")
    + "					</div>\n					<div class=\"right-style\">\n						<h3>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"header") : depth0), depth0)) != null ? stack1 : "")
    + "</h3>\n						<p>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"paragraph") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\n						<p>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"link") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\n					</div>\n				</div>\n			</div>\n		</section>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <style type=\"text/css\">\n				.pr-background-image{\n					background: url('"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"backgroundImage") : depth0), depth0))
    + "') no-repeat;\n					background-size: cover;\n				}\n    </style>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "pr-background-image";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "						    <div class=\"top-header\"><h3>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"top-header") : depth0), depth0)) != null ? stack1 : "")
    + "</h3></div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row\">\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":1},"end":{"line":28,"column":10}}})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/preferred-rewards-module",
  "version": "3.0.0",
  "id": "preferredRewardsModule",
  "containerID": "homeLoansPreferredRewardsModule",
  "moduleName": "home-loans-preferred-rewards-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "preferred-rewards-module",
  "data": {
    "init": "preferredRewardsModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

/**
 * The PreferredRewardsModule Sparta Module.
 * It's simple text module
 * @export
 * @class preferredRewardsModule
 * @extends Module
 */
class preferredRewardsModule extends Module {
  /**
   * Initialize the module
   * @method constructor
   * @param {object} options options object
   * @param {object} context context object
   * @returns {void}
   */
  constructor(options, context) {
    // Extend Module
    super({
      ...options,
      context,
      config: _moduleConfig
    });

    // if route is mortgage
    this.$target = $('#preferredRewardsModule');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
  }

  /**
   * @method init
   * @memberof preferredRewardsModule
   * @desc Initialize module
   * @returns {void}
   */
  init() {}
}
registerModuleClass({
  moduleClass: preferredRewardsModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { preferredRewardsModule as default, moduleConfig };
